import React, { Component } from 'react'
import { connect } from 'react-redux'
import "whatwg-fetch"

import { receiveLink } from '../actions/mylink'
import { jsonResponseHandler } from '../utils/FetchHelper'
import MyLinkList from "../components/link/MyLinkList";
import LoadingBox from "../components/common/LoadingBox";
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import {addPrefix} from "../utils/UriUtil";


@connect(state => ({}), dispatch => ({
	handleReceiveMyLink(data) {
		dispatch(receiveLink(data))
	},
    dispatch
}))
class LinkApp extends Component {

	constructor(props, context) {
		super(props, context)
		this.state = {
            initialized : InitStatus.INIT_READY,
        }
        this.init = this.init.bind(this);
	}

	componentDidMount() {
        this.init();
    }

    init() {
		const { handleReceiveMyLink, dispatch } = this.props

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/link/my.json"), {
			credentials: "include",
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				handleReceiveMyLink(data);
				this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
				})
			})
            .catch(e => {
                console.error(e);
                this.setState({
                    initialized : InitStatus.INIT_FAIL,
                })
            });
    }


	render() {
		const { initialized } = this.state
		return (
				<div className="inner_article link_article">
					<h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
                    { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
                    { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
                    {(initialized === InitStatus.INIT_SUCCESS ) &&
						<div className="blog_mylink">
							<h3 className="tit_cont">나의 링크</h3>
							<MyLinkList />
						</div>
					}
				</div>
		)
	}
}

export default LinkApp
